import Delivery from '@/generated/classes/Delivery';
export default class DeliveryExtend extends Delivery {
  constructor() {
    super();
  }
}
